import { createFileRoute } from '@tanstack/react-router';
import Apps from '../../../administration/src/components/Apps';

export const Route = createFileRoute('/_secured/administration/apps')({
  component: Apps,
});
